import AppConstants from "../../../../constants/AppConstants";
import { TITLE, DESC } from "./GalleryImageConstants";

const { INPUT_SOURCE_PROPERTY_INPUT } = AppConstants;

/** Returns differences in b from a */
export const diffObjects = (a, b) =>
  Object.entries(b).reduce(
    (result, [key, value]) => (a[key] !== value ? { ...result, [key]: value } : result),
    {}
  );

/**
 * @typedef {Object} ThumbState
 * @property {string?=} title
 * @property {string?=} desc
 */

/** Formats props into an update */
export const prepareUpdate = (name, value, origValue, addUndo) => ({
  addUndo,
  name,
  origValue,
  source: INPUT_SOURCE_PROPERTY_INPUT,
  value,
});

/**
 * Generates a list containing an undo point and updates (if any deviation from original state)
 * @param {number} index
 * @param {ThumbState} update
 * @param {ThumbState} original
 * @returns
 */
export const prepareUpdates = (index, update, original) => {
  const updateProps = Object.entries(diffObjects(original, update)) || [];
  const propNames = {
    title: `content.items.${index}.${TITLE}`,
    desc: `content.items.${index}.${DESC}`,
  };

  return updateProps.reduce((result, [key, value], i) => {
    const singleUpdate = prepareUpdate(propNames[key], value, original[key], false);
    return [
      ...result,
      ...(!i
        ? [prepareUpdate(propNames[key], original[key], original[key], true), singleUpdate]
        : [singleUpdate]),
    ];
  }, []);
};

/**
 * Creates initial details state from an asset
 * @param {Map} asset - The asset to create details from
 * @returns {ThumbState}
 */
export const createInitialDetails = (asset) => ({
  [TITLE]: asset.get(TITLE),
  [DESC]: asset.get(DESC, ""),
});

/**
 * Updates details state with new values
 * @param {Object} details - Current details state
 * @param {Object} original - Original values
 * @param {string} key - Key to update
 * @param {*} newValue - New value to set
 * @returns {Object} Updated details state
 */
export const updateDetailsState = (details, original, key, newValue) => {
  const updated = { ...details, [key]: newValue };
  return {
    ...updated,
    touched: !!Object.keys(diffObjects(original, updated)).length,
  };
};
